import FixedBottomNavigation from '.';

export default function BottomNavigatorLoader() {
	return <FixedBottomNavigation/>
}
